var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{class:_vm.className},[_vm._v(" 本网站系统的所有权及最终解释权归上海师范大学招生办公室所有 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }